import type { VFrameBase } from '@festina/life-general-types/life'
import type { Optional } from '@festina-life/core'

import { useFrameContext } from '../forms/frameContext'
import { useLifeFormikContext } from '../forms/useLifeFormikContext'

export const useFieldVFrame = (name: string): Optional<VFrameBase> => {
  const { status } = useLifeFormikContext()
  const { fieldVFrame } = useFrameContext()

  if (status.fieldVFrame) {
    return status.fieldVFrame(name) // old way takes precedence
  }
  if (fieldVFrame) {
    return fieldVFrame(name) // new way will eventually replace old way (then we may or not need this file anymore)
  }
  return null
}
